import { useLocation } from 'react-router-dom';
import Seo from './Seo';

const BROWNIE_IMAGE = 'https://api.brow-mie.com/api/system/products/16/image.webp?width=1200&format=webp';

const HOME_SCHEMA = [
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      ['มีบริการจัดส่งแบบไหนบ้าง?', 'ส่งด่วนด้วยไรเดอร์ Lalamove ในกรุงเทพฯ และปริมณฑล หรือส่งทางไปรษณีย์ทั่วประเทศ เลือกได้ตอนชำระเงิน'],
      ['ชำระเงินอย่างไรได้บ้าง?', 'ชำระด้วยบัตรเครดิตหรือเดบิต หรือสแกน PromptPay QR ผ่านระบบชำระเงินที่ปลอดภัย'],
      ['ติดตามออเดอร์ได้อย่างไร?', 'หลังชำระเงินจะมีหน้าติดตามออเดอร์ และรับอัปเดตทาง LINE หรืออีเมลได้'],
      ['สั่งผ่าน LINE ได้ไหม?', 'แชทกับน้องมี่ที่ LINE @279iboef บอกเมนูที่ต้องการ แล้วรับลิงก์ชำระเงินในแชท'],
      ['สั่งล่วงหน้าได้ไหม?', 'เลือกวันและเวลาจัดส่งล่วงหน้าได้สูงสุด 7 วันตอนชำระเงิน'],
    ].map(([name, text]) => ({
      '@type': 'Question',
      name,
      acceptedAnswer: { '@type': 'Answer', text },
    })),
  },
];

const SONG_WAT_FAQ = [
  ['ทรงวาดอยู่ที่ไหน?', 'ถนนทรงวาดอยู่ในเขตสัมพันธวงศ์ ใกล้เยาวราช สำเพ็ง และแม่น้ำเจ้าพระยา'],
  ['ทรงวาดลง MRT สถานีอะไร?', 'ลง MRT สถานีวัดมังกร ทางออก 1 แล้วเดินผ่านถนนแปลงนามและเยาวพานิชย์เข้าสู่ย่านทรงวาด'],
  ['เที่ยวทรงวาดใช้เวลากี่ชั่วโมง?', 'ควรเผื่อประมาณ 2–4 ชั่วโมงสำหรับเดินเล่น กินอาหาร แวะร้านขนมและถ่ายรูป'],
  ['เที่ยวทรงวาดกับเยาวราชวันเดียวกันได้ไหม?', 'ได้ ทั้งสองย่านอยู่ใกล้กันและสามารถเดินเชื่อมกันได้'],
  ['Browmie ทรงวาดเปิดกี่โมง?', 'หน้าร้านเปิดจันทร์–ศุกร์ 10:00–18:00 น. และเสาร์–อาทิตย์ 10:00–19:00 น.'],
];

const SONG_WAT_SHOP_FAQ = [
  ['Browmie ทรงวาดเป็นร้านอะไร?', 'Browmie เป็นร้านบราวนี่และขนมโฮมเมดบนถนนทรงวาด เมนูเด่นคือ Brownie Brittle บางกรอบเพียง 1 มม.'],
  ['ร้าน Browmie ทรงวาดอยู่ตรงไหน?', 'ร้านอยู่ที่ 953/1 ถนนทรงวาด แขวงสัมพันธวงศ์ เขตสัมพันธวงศ์ กรุงเทพฯ 10100 แนะนำเปิดหมุดแผนที่เพื่อเดินมายังหน้าร้านได้ตรงที่สุด'],
  ['Browmie ทรงวาดเปิดกี่โมง?', 'เปิดจันทร์–ศุกร์ 10:00–18:00 น. และเสาร์–อาทิตย์ 10:00–19:00 น. เวลาทำการอาจเปลี่ยนในวันหยุดพิเศษ'],
  ['Brownie Brittle ต่างจากบราวนี่ปกติอย่างไร?', 'Brownie Brittle ของ Browmie อบบางเพียง 1 มม. จึงเน้นความกรอบและเบา ต่างจากบราวนี่ทั่วไปที่มีเนื้อหนา นุ่ม หรือหนึบกว่า'],
  ['สั่งขนมล่วงหน้าหรือส่งถึงบ้านได้ไหม?', 'ได้ สามารถดูเมนูและสั่งผ่านเว็บไซต์ Browmie โดยมีตัวเลือกจัดส่งด่วนในกรุงเทพฯ และจัดส่งทั่วประเทศตามสินค้าที่รองรับ'],
];

const BROWMIE_BRAND_FAQ = [
  ['Browmie คืออะไร?', 'Browmie (บราวมี่) คือแบรนด์บราวนี่และเบเกอรี่ไทยจากกรุงเทพฯ เริ่มต้นในปี 2018 และมีหน้าร้านบนถนนทรงวาด'],
  ['Browmie สะกดอย่างไร?', 'ชื่อแบรนด์สะกดว่า Browmie ใช้ตัวอักษร B-r-o-w-m-i-e และอ่านภาษาไทยว่า บราวมี่'],
  ['Browmie กับ brownie ต่างกันอย่างไร?', 'Browmie คือชื่อแบรนด์ ส่วน brownie คือชื่อขนมประเภทบราวนี่ เมนูซิกเนเจอร์ของแบรนด์คือ Brownie Brittle ที่อบบางกรอบประมาณ 1 มม.'],
  ['ร้าน Browmie อยู่ที่ไหน?', 'หน้าร้าน Browmie อยู่ที่ 953/1 ถนนทรงวาด แขวงสัมพันธวงศ์ เขตสัมพันธวงศ์ กรุงเทพฯ 10100'],
  ['สั่ง Browmie ออนไลน์ได้ไหม?', 'สั่งผลิตภัณฑ์ Browmie ผ่าน brow-mie.com ได้ โดยมีตัวเลือกส่งด่วนในกรุงเทพฯ และจัดส่งทั่วประเทศไทยตามสินค้าที่รองรับ'],
];

const BROWNIE_FAQ = [
  ['บราวนี่ของ Browmie มีแบบไหนบ้าง?', 'Browmie มี Brownie Brittle บางกรอบประมาณ 1 มม. บราวนี่กรอบสอดไส้ และเซตบราวนี่สำหรับแบ่งกันหรือเป็นของฝาก ตรวจสอบเมนูปัจจุบันได้บนเว็บไซต์'],
  ['Brownie Brittle ต่างจากบราวนี่ปกติอย่างไร?', 'Brownie Brittle ของ Browmie อบเป็นแผ่นบางกรอบประมาณ 1 มม. จึงมีสัมผัสเบาและกรอบ ต่างจากบราวนี่ทั่วไปที่มักเป็นชิ้นหนา เนื้อนุ่มหรือหนึบ'],
  ['สั่งบราวนี่ออนไลน์ได้ไหม?', 'สั่งบราวนี่จาก Browmie ผ่าน brow-mie.com ได้โดยตรง เลือกสินค้า จำนวน วิธีรับสินค้า และชำระเงินผ่านเว็บไซต์'],
  ['บราวนี่ส่งต่างจังหวัดได้ไหม?', 'ผลิตภัณฑ์ที่รองรับสามารถจัดส่งทั่วประเทศไทยได้ ส่วนการส่งด่วนในกรุงเทพฯ และปริมณฑลมีตัวเลือกไรเดอร์ตอนชำระเงิน'],
  ['ร้านบราวนี่ Browmie อยู่ที่ไหน?', 'หน้าร้าน Browmie อยู่ที่ 953/1 ถนนทรงวาด แขวงสัมพันธวงศ์ เขตสัมพันธวงศ์ กรุงเทพฯ 10100'],
];

const PRIVATE_PREFIXES = ['/cart', '/checkout', '/order', '/line-callback', '/account', '/rewards'];

export default function RouteSeo() {
  const { pathname } = useLocation();
  const seoPath = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;

  if (seoPath === '/') {
    return (
      <Seo
        title="Browmie | บราวนี่กรอบบาง 1 มม. และบราวนี่โฮมเมด ทรงวาด"
        description="Browmie ร้านบราวนี่โฮมเมดที่ทรงวาด เจ้าของ Brownie Brittle บางกรอบเพียง 1 มม. อบสด ส่งด่วนในกรุงเทพฯ และจัดส่งทั่วประเทศไทย"
        image={BROWNIE_IMAGE}
        imageAlt="Brownie Brittle บางกรอบ 1 มม. ของ Browmie"
        jsonLd={HOME_SCHEMA}
      />
    );
  }

  if (seoPath === '/marketplace') {
    return (
      <Seo
        title="สั่งบราวนี่ออนไลน์ | บราวนี่กรอบและคุกกี้ Browmie"
        description="เลือกซื้อ Brownie Brittle บางกรอบ 1 มม. บราวนี่และคุกกี้โฮมเมดจาก Browmie อบสด พร้อมส่งกรุงเทพฯ และทั่วประเทศ"
        canonicalPath="/marketplace"
        image={BROWNIE_IMAGE}
        imageAlt="บราวนี่และคุกกี้โฮมเมดจาก Browmie"
        jsonLd={[{
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: 'ร้านค้าออนไลน์ Browmie',
          url: 'https://brow-mie.com/marketplace',
          description: 'ร้านค้าออนไลน์สำหรับบราวนี่กรอบ บราวนี่และคุกกี้โฮมเมดของ Browmie',
          isPartOf: { '@type': 'WebSite', name: 'Browmie', url: 'https://brow-mie.com/' },
        }]}
      />
    );
  }

  if (seoPath === '/about-browmie') {
    const canonical = 'https://brow-mie.com/about-browmie';
    return (
      <Seo
        title="Browmie คืออะไร? รู้จักแบรนด์บราวมี่จากทรงวาด"
        description="Browmie (บราวมี่) คือแบรนด์บราวนี่ไทยจากกรุงเทพฯ เจ้าของ Brownie Brittle บางกรอบ 1 มม. รู้จักชื่อแบรนด์ เรื่องราว และหน้าร้านทรงวาด"
        canonicalPath="/about-browmie"
        image={BROWNIE_IMAGE}
        imageAlt="Browmie แบรนด์บราวนี่ไทยและ Brownie Brittle บางกรอบ 1 มม."
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            '@id': `${canonical}#webpage`,
            name: 'Browmie (บราวมี่) แบรนด์บราวนี่ไทย',
            alternateName: ['About Browmie', 'รู้จัก Browmie'],
            url: canonical,
            description: 'Browmie คือแบรนด์บราวนี่และเบเกอรี่ไทยจากกรุงเทพฯ มีหน้าร้านบนถนนทรงวาด และมี Brownie Brittle บางกรอบ 1 มม. เป็นเมนูซิกเนเจอร์',
            inLanguage: ['th-TH', 'en'],
            isPartOf: { '@id': 'https://brow-mie.com/#website' },
            mainEntity: { '@id': 'https://brow-mie.com/#bakery' },
            about: { '@id': 'https://brow-mie.com/#bakery' },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: 'Browmie', item: 'https://brow-mie.com/' },
              { '@type': 'ListItem', position: 2, name: 'รู้จัก Browmie', item: canonical },
            ],
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: BROWMIE_BRAND_FAQ.map(([name, text]) => ({
              '@type': 'Question',
              name,
              acceptedAnswer: { '@type': 'Answer', text },
            })),
          },
        ]}
      />
    );
  }

  if (seoPath === '/brownie') {
    const canonical = 'https://brow-mie.com/brownie';
    const products = [
      { position: 1, name: 'Brownie Brittle', url: 'https://brow-mie.com/product/16' },
      { position: 2, name: 'More (than) Brittle - Box', url: 'https://brow-mie.com/product/24' },
      { position: 3, name: 'Brownie brittle set', url: 'https://brow-mie.com/product/27' },
      { position: 4, name: 'Signature Set', url: 'https://brow-mie.com/product/26' },
    ];
    return (
      <Seo
        title="Brownie & บราวนี่กรอบบาง 1 มม. | Browmie"
        description="เลือก Brownie และบราวนี่กรอบจาก Browmie ทั้ง Brownie Brittle บาง 1 มม. บราวนี่กรอบสอดไส้และเซตของฝาก สั่งออนไลน์หรือแวะร้านทรงวาด"
        canonicalPath="/brownie"
        image={BROWNIE_IMAGE}
        imageAlt="Brownie และบราวนี่กรอบบาง 1 มม. จาก Browmie"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            '@id': `${canonical}#webpage`,
            name: 'Brownie และบราวนี่จาก Browmie',
            alternateName: ['บราวนี่ Browmie', 'Browmie brownies'],
            url: canonical,
            description: 'รวม Brownie Brittle บางกรอบ 1 มม. บราวนี่กรอบสอดไส้ และเซตบราวนี่จาก Browmie',
            inLanguage: ['th-TH', 'en'],
            isPartOf: { '@id': 'https://brow-mie.com/#website' },
            about: { '@type': 'Thing', name: 'Brownie', alternateName: 'บราวนี่' },
            mainEntity: {
              '@type': 'ItemList',
              name: 'บราวนี่จาก Browmie',
              itemListElement: products.map((product) => ({
                '@type': 'ListItem',
                position: product.position,
                name: product.name,
                url: product.url,
              })),
            },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: 'Browmie', item: 'https://brow-mie.com/' },
              { '@type': 'ListItem', position: 2, name: 'Brownie และบราวนี่', item: canonical },
            ],
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: BROWNIE_FAQ.map(([name, text]) => ({
              '@type': 'Question',
              name,
              acceptedAnswer: { '@type': 'Answer', text },
            })),
          },
        ]}
      />
    );
  }

  if (seoPath === '/songwat-guide') {
    const canonical = 'https://brow-mie.com/songwat-guide';
    return (
      <Seo
        title="เที่ยวทรงวาด 2026: กิน เที่ยว การเดินทาง | Browmie"
        description="คู่มือเที่ยวทรงวาดโดย Browmie รวมวิธีเดินทางจาก MRT วัดมังกร เส้นทางครึ่งวัน ของกิน มุมถ่ายรูป ของฝาก และข้อมูลหน้าร้าน Browmie"
        canonicalPath="/songwat-guide"
        image={BROWNIE_IMAGE}
        imageAlt="คู่มือเที่ยวทรงวาดและร้าน Browmie"
        ogType="article"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: 'เที่ยวทรงวาด 2026: กิน เที่ยว การเดินทาง และของฝาก',
            description: 'คู่มือเที่ยวทรงวาดโดย Browmie พร้อมเส้นทางครึ่งวัน วิธีเดินทาง ของกิน มุมถ่ายรูป และของฝาก',
            image: [BROWNIE_IMAGE],
            datePublished: '2026-08-27',
            dateModified: '2026-08-27',
            inLanguage: ['th-TH', 'en'],
            author: { '@type': 'Organization', name: 'Browmie', url: 'https://brow-mie.com/' },
            publisher: { '@type': 'Organization', name: 'Browmie', url: 'https://brow-mie.com/', logo: { '@type': 'ImageObject', url: 'https://brow-mie.com/logo512.png' } },
            mainEntityOfPage: canonical,
          },
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: 'Browmie', item: 'https://brow-mie.com/' },
              { '@type': 'ListItem', position: 2, name: 'คู่มือเที่ยวทรงวาด', item: canonical },
            ],
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: SONG_WAT_FAQ.map(([name, text]) => ({
              '@type': 'Question',
              name,
              acceptedAnswer: { '@type': 'Answer', text },
            })),
          },
        ]}
      />
    );
  }

  if (seoPath === '/songwat-brownie-shop') {
    const canonical = 'https://brow-mie.com/songwat-brownie-shop';
    return (
      <Seo
        title="ร้านขนมทรงวาด | Browmie บราวนี่กรอบบาง 1 มม."
        description="Browmie ร้านบราวนี่และขนมบนถนนทรงวาด กรุงเทพฯ แวะชิม Brownie Brittle บางกรอบ 1 มม. ดูที่อยู่ เวลาเปิด การเดินทาง และสั่งล่วงหน้า"
        canonicalPath="/songwat-brownie-shop"
        image={BROWNIE_IMAGE}
        imageAlt="ร้าน Browmie และบราวนี่กรอบบาง 1 มม. ที่ถนนทรงวาด"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'ร้านขนมทรงวาด Browmie',
            alternateName: 'Browmie brownie shop in Song Wat',
            url: canonical,
            description: 'ข้อมูลหน้าร้าน Browmie บนถนนทรงวาด พร้อมเมนูเด่น ที่อยู่ เวลาเปิด และวิธีเดินทาง',
            inLanguage: ['th-TH', 'en'],
            mainEntity: { '@id': 'https://brow-mie.com/#bakery' },
            about: { '@type': 'Place', name: 'ถนนทรงวาด', alternateName: 'Song Wat Road' },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: 'Browmie', item: 'https://brow-mie.com/' },
              { '@type': 'ListItem', position: 2, name: 'หน้าร้าน Browmie ทรงวาด', item: canonical },
            ],
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: SONG_WAT_SHOP_FAQ.map(([name, text]) => ({
              '@type': 'Question',
              name,
              acceptedAnswer: { '@type': 'Answer', text },
            })),
          },
        ]}
      />
    );
  }

  if (seoPath === '/privacy-policy') {
    return (
      <Seo
        title="Privacy Notice | Browmie"
        description="ประกาศความเป็นส่วนตัวของ Browmie สำหรับเว็บไซต์ ร้านค้าออนไลน์ บัญชีลูกค้า ระบบสมาชิก และบริการจัดส่ง"
        canonicalPath="/privacy-policy"
      />
    );
  }

  if (seoPath.startsWith('/product/')) {
    return (
      <Seo
        title="สินค้า Browmie | บราวนี่และคุกกี้โฮมเมด"
        description="ดูรายละเอียด ราคา และสั่งซื้อบราวนี่หรือคุกกี้โฮมเมดจาก Browmie พร้อมจัดส่งในกรุงเทพฯ และทั่วประเทศไทย"
        canonicalPath={seoPath}
        image={BROWNIE_IMAGE}
        ogType="product"
      />
    );
  }

  if (PRIVATE_PREFIXES.some((prefix) => seoPath === prefix || seoPath.startsWith(`${prefix}/`))) {
    return (
      <Seo
        title="Browmie"
        description="บริการสั่งซื้อและบัญชีลูกค้า Browmie"
        canonicalPath={seoPath}
        robots="noindex, follow"
      />
    );
  }

  return (
    <Seo
      title="ไม่พบหน้านี้ | Browmie"
      description="ไม่พบหน้าที่คุณกำลังค้นหา"
      canonicalPath={seoPath}
      robots="noindex, follow"
    />
  );
}
